import React from 'react'
import styles from './SectionIndicatorLegend.module.css'

export const SectionIndicatorLegend: React.FC = () => {
  return (
    <div className={styles.legend}>
      <div className={styles.legendItem}>
        <div className={`${styles.indicator} ${styles.indicatorNone}`}></div>
        <span className={styles.legendText}>No prompt in database</span>
      </div>
      <div className={styles.legendItem}>
        <div className={`${styles.indicator} ${styles.indicatorDisabled}`}></div>
        <span className={styles.legendText}>Prompt in database, AI auditing disabled</span>
      </div>
      <div className={styles.legendItem}>
        <div className={`${styles.indicator} ${styles.indicatorEnabled}`}>✓</div>
        <span className={styles.legendText}>Prompt in database, AI auditing enabled</span>
      </div>
    </div>
  )
}
